import { type ButtonProps, Button as TineButton } from "@tine/designsystem-ui-react";
import { type ForwardedRef, forwardRef, type MouseEvent, type PropsWithChildren } from "react";
import { navigate } from "wouter/use-browser-location";

import { sendButtonClick } from "../common/tracking";
import { isExternalLink } from "../common/utils";

type TrackedButtonProps = PropsWithChildren<ButtonProps> & { trackingName?: string };

const Button = forwardRef<HTMLButtonElement, TrackedButtonProps>(
   (
      {
         size = "compact",
         iconPosition = "right",
         className = "",
         onClick,
         to,
         trackingName,
         children,
         ...rest
      }: TrackedButtonProps,
      ref: ForwardedRef<HTMLButtonElement>
   ) => {
      const buttonName = trackingName ?? children?.toString();
      const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
         sendButtonClick(buttonName);
         if (to && !isExternalLink(to)) {
            navigate(to);
            e.preventDefault();
         }
         onClick?.(e);
      };
      return (
         <TineButton
            size={size}
            iconPosition={iconPosition}
            className={className}
            onClick={handleClick}
            to={to}
            {...rest}
            ref={ref}
         >
            {children}
         </TineButton>
      );
   }
);

export default Button;
